import React, { useEffect, useState } from 'react'
import DataComplaints from './DataComplaints'
import { ComplaintInterface, DefaultComplaintInterface, ShowComplaintsContext } from './types'
import AddComplaint from './AddComplaints'
import SuccessMsg from '../../Messages/SuccessMsg'
import EditComplaint from './EditComplaint'
import DeleteComplaint from './DeleteComplaint'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { Outlet, useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { ShowComplaintApi } from '../../redux/complaints/complaintApiCalls'

const ShowComplaints:React.FC = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedComplaint, setSelectedComplaint] = useState<ComplaintInterface>(DefaultComplaintInterface)
  const [selectedDoctor, setSelectedDoctor] = useState<any[]>([]);
  const [hideDataComplaint, setHideDataComplaint] = useState(false)
  const navigate = useNavigate()

  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchAss = async () => {
      await dispatch(ShowComplaintApi());
    };
    fetchAss();
  }, [dispatch]);


  return (
    <ShowComplaintsContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showEditModal, setShowEditModal,
      showDeleteModal, setShowDeleteModal,
      selectedComplaint, setSelectedComplaint,
      selectedDoctor, setSelectedDoctor,
      hideDataComplaint, setHideDataComplaint,
      showAddModal, setShowAddModal
    }}>
      {showSuccessMsg && <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/> }

      {showAddModal && <AddComplaint modal={showAddModal} toggle={() => setShowAddModal(!showAddModal)} /> }

      <div className="flex justify-start gap-2 mt-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
        <button className="p-2 rounded btn-main" onClick={() => setShowAddModal(!showAddModal)}>
          <FaPlus />
        </button>
      </div>
      <DataComplaints />

      {showEditModal && selectedComplaint?._id && <EditComplaint ComplaintData={selectedComplaint} modal={showEditModal}  toggle={() => setShowEditModal(!showEditModal)} />}
      {showDeleteModal && selectedComplaint?._id && <DeleteComplaint ComplaintData={selectedComplaint} modal={showDeleteModal}  toggle={() => setShowDeleteModal(!showDeleteModal)} />}
      <Outlet />
    </ShowComplaintsContext.Provider>
  )
}

export default ShowComplaints
